export * from './client';
export * from './hooks/useSendEmail';
export * from './types';
// Re-export types from @sendgrid/mail for convenience
export type { MailDataRequired } from '@sendgrid/mail';

// Export the default client instance
export { sendGridClient as default } from './client';
